import { Col, Row } from "react-bootstrap"
import styles from "./general.module.scss"

const StandardsMasteryColorLengend = () => {
  return (
    <div className="mt-3 w-75 text-start">
        <h5>Legend:</h5>
        <Row>
            <Col xs={{ span: 12, order: 1 }} md={{ span: 6, order: 1 }}>
                <div className="d-flex align-items-center">
                    <span className={styles.standardsMasteryColorBox} style={{ backgroundColor: '#F44336' }}></span>
                    <span>Not Mastered</span>
                </div>
            </Col>
            <Col xs={{ span: 12, order: 2 }} md={{ span: 6, order: 3 }}>
                <div className="d-flex align-items-center">
                    <span className={styles.standardsMasteryColorBox} style={{ backgroundColor: '#FF9800' }}></span>
                    <span>Approaches Mastery</span>
                </div>
            </Col>
            <Col xs={{ span: 12, order: 3 }} md={{ span: 6, order: 2 }}>
                <div className="d-flex align-items-center">
                    <span className={styles.standardsMasteryColorBox} style={{ backgroundColor: '#4CAF50' }}></span>
                    <span>Mastered</span>
                </div>
            </Col>
            <Col xs={{ span: 12, order: 4 }} md={{ span: 6, order: 4 }}>
                <div className="d-flex align-items-center">
                    <span className={styles.standardsMasteryColorBox} style={{ backgroundColor: '#0000FF' }}></span>
                    <span>Exceeds Mastery</span>
                </div>
            </Col>
            </Row>
    </div>
  )
}

export default StandardsMasteryColorLengend
